import {
  HandCoins,
  ShoppingCart,
  Warehouse,
  BarChart3,
  BookOpen,
  LayoutDashboard,
  Bell,
  CalendarCheck,
  CarFront,
  CheckSquare,
  ClipboardList,
  ClipboardCheck,
  Bug,
  Plug,
  Route as RouteIcon,
  Fuel,
  ListChecks,
  Receipt,
  TriangleAlert,
  Wrench,
  FileLock2,
  FileSpreadsheet,
  FileText,
  Gavel,
  Inbox,
  GitPullRequestArrow,
  History,
  KeyRound,
  LifeBuoy,
  MapPinned,
  MessagesSquare,
  Presentation,
  Scale,
  Settings2,
  ShieldCheck,
  Sparkles,
  Sun,
  Target,
  Truck,
  Umbrella,
  Users,
  CalendarDays,
  Clock4,
  Timer,
  Wallet,
  Percent,
  PackageCheck,
  Palmtree,
  type LucideIcon,
} from 'lucide-react';

export interface NavAccent {
  /** Kolor akcentu widoku (hex) — ikona w sidebarze, poświata i pasek w nagłówku strony (styl ZUR OPS). */
  color: string;
  icon: LucideIcon;
}

/** Najdłuższy pasujący prefiks wygrywa; `/` musi być ostatni. */
const ACCENTS: Array<[prefix: string, accent: NavAccent]> = [
  ['/manager', { color: '#0ea5e9', icon: LayoutDashboard }],
  ['/mbr', { color: '#6366f1', icon: Presentation }],
  ['/analytics/rep-sales', { color: '#0891b2', icon: FileSpreadsheet }],
  ['/analytics', { color: '#10b981', icon: BarChart3 }],
  ['/customers', { color: '#3b82f6', icon: Users }],
  ['/leads', { color: '#8b5cf6', icon: Target }],
  ['/visits', { color: '#0ea5e9', icon: CalendarCheck }],
  ['/tasks', { color: '#14b8a6', icon: CheckSquare }],
  ['/my-daily-report', { color: '#65a30d', icon: ClipboardList }],
  ['/notifications', { color: '#f59e0b', icon: Bell }],
  ['/chat', { color: '#d946ef', icon: MessagesSquare }],
  ['/workflow', { color: '#6366f1', icon: GitPullRequestArrow }],
  ['/fleet/analytics', { color: '#10b981', icon: BarChart3 }],
  ['/fleet/routes', { color: '#f59e0b', icon: RouteIcon }],
  ['/fleet/integration', { color: '#0891b2', icon: Plug }],
  ['/fleet/leases', { color: '#8b5cf6', icon: CarFront }],
  ['/fleet/logbooks', { color: '#f97316', icon: CarFront }],
  ['/fleet/my-logbooks', { color: '#14b8a6', icon: CarFront }],
  ['/fleet/fuel', { color: '#eab308', icon: Fuel }],
  ['/fleet/expenses', { color: '#10b981', icon: Receipt }],
  ['/fleet/incidents', { color: '#ef4444', icon: TriangleAlert }],
  ['/fleet/checklists', { color: '#0ea5e9', icon: ClipboardCheck }],
  ['/fleet/service', { color: '#a855f7', icon: Wrench }],
  ['/fleet/templates', { color: '#6366f1', icon: ListChecks }],
  ['/fleet/settings', { color: '#64748b', icon: CarFront }],
  ['/fleet', { color: '#06b6d4', icon: CarFront }],
  ['/logistics', { color: '#f97316', icon: Truck }],
  ['/planner/setup', { color: '#14b8a6', icon: ListChecks }],
  ['/planner', { color: '#6366f1', icon: CalendarDays }],
  ['/worktime/settings', { color: '#64748b', icon: ShieldCheck }],
  ['/worktime/my', { color: '#0d9488', icon: Timer }],
  ['/worktime', { color: '#10b981', icon: Clock4 }],
  ['/leave', { color: '#f59e0b', icon: Palmtree }],
  ['/insurance/queue', { color: '#f59e0b', icon: Inbox }],
  ['/insurance/claims', { color: '#ef4444', icon: ClipboardList }],
  ['/insurance/tenders', { color: '#8b5cf6', icon: Gavel }],
  ['/insurance/policies', { color: '#0ea5e9', icon: FileText }],
  ['/insurance/analytics', { color: '#10b981', icon: BarChart3 }],
  ['/insurance/import', { color: '#0891b2', icon: FileSpreadsheet }],
  ['/insurance/settings', { color: '#64748b', icon: Settings2 }],
  ['/insurance', { color: '#2b8fe0', icon: Umbrella }],
  ['/finance/collections', { color: '#e11d48', icon: HandCoins }],
  ['/quality/analytics', { color: '#10b981', icon: BarChart3 }],
  ['/quality/events', { color: '#f59e0b', icon: ClipboardList }],
  ['/quality/suppliers', { color: '#0ea5e9', icon: FileText }],
  ['/quality', { color: '#ef4444', icon: ClipboardList }],
  ['/integrations/erp-outbox', { color: '#7c3aed', icon: Inbox }],
  ['/integrations', { color: '#0891b2', icon: Plug }],
  ['/admin/live', { color: '#ef4444', icon: MapPinned }],
  ['/admin/ai', { color: '#a855f7', icon: Sparkles }],
  ['/admin/settings', { color: '#64748b', icon: Settings2 }],
  ['/admin/dictionaries', { color: '#0d9488', icon: BookOpen }],
  ['/admin/users', { color: '#ec4899', icon: Users }],
  ['/admin/roles', { color: '#2b8fe0', icon: KeyRound }],
  ['/admin/audit', { color: '#f59e0b', icon: History }],
  ['/admin/gdpr', { color: '#8b5cf6', icon: FileLock2 }],
  ['/admin/consents', { color: '#10b981', icon: ShieldCheck }],
  ['/admin', { color: '#64748b', icon: Settings2 }],
  ['/legal', { color: '#94a3b8', icon: Scale }],
  ['/feedback', { color: '#f43f5e', icon: Bug }],
  ['/help', { color: '#0ea5e9', icon: LifeBuoy }],
  ['/costs', { color: '#d97706', icon: Wallet }],
  ['/finance/cashflow', { color: '#059669', icon: Wallet }],
  ['/purchasing', { color: '#16a34a', icon: ShoppingCart }],
  ['/sales/commissions', { color: '#16a34a', icon: Percent }],
  ['/sales/orders', { color: '#1f78c4', icon: PackageCheck }],
  ['/warehouse', { color: '#0d9488', icon: Warehouse }],
  ['/surveys', { color: '#8b5cf6', icon: ClipboardList }],
];

const HOME: NavAccent = { color: '#14b8a6', icon: Sun };

export function accentForPath(pathname: string): NavAccent {
  if (pathname === '/' || pathname === '') return HOME;
  for (const [prefix, accent] of ACCENTS) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) return accent;
  }
  return HOME;
}

export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  const n = parseInt(h.length === 3 ? h.replace(/./g, (c) => c + c) : h, 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
}
